export default __webpack_public_path__ + "static/media/modarres.1ac6994d.jpg";